import React, { useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';

import {
    shouldShowPostLoginContinueAlert,
    useContinueOrgEnrollment,
} from '../components/useContinueOrgEnrollment';
import { EnrollmentContext } from '../enroll/context';

import { LoadingScreen } from 'components/loading-screen/LoadingScreen';
import { withAuth } from 'features/auth/components/withAuth';

export const OrgEnrollmentContinue = withAuth()(() => {
    const { onProgressLoaded } = useContext(EnrollmentContext);
    const { search } = useLocation();
    const { getContinueAlert, getEnrollmentProgress, getOrgApprovedAlertIfNeeded } =
        useContinueOrgEnrollment();

    useEffect(() => {
        const loadProgress = async () => {
            const progress = await getEnrollmentProgress();
            if (shouldShowPostLoginContinueAlert(search)) {
                await getContinueAlert();
            } else {
                await getOrgApprovedAlertIfNeeded(progress);
            }
            onProgressLoaded(progress);
        };
        loadProgress();
    }, [
        getContinueAlert,
        getEnrollmentProgress,
        onProgressLoaded,
        getOrgApprovedAlertIfNeeded,
        search,
    ]);

    return <LoadingScreen />;
});
